import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconLogin = (props) => (
  <Icon fill="none" {...props}>
    <path
      d="M14.9807 19.0793C20.0145 19.0793 24.0952 15.0321 24.0952 10.0397C24.0952 5.0472 20.0145 1 14.9807 1C9.94695 1 5.86625 5.0472 5.86625 10.0397C5.86625 15.0321 9.94695 19.0793 14.9807 19.0793Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.61242 17.394C4.90069 19.3475 1.46345 23.7524 1 29"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29 29C28.5365 23.7524 25.0993 19.3092 20.3876 17.394"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
